'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	TAG_FILTER_PREFIX = 'tag:',
	trucateSentence = require('../models/truncate-sentence');

mmWidgets.fn.selectedTagFilterWidget = function (fileListModel) {
	return mmWidgets.each(this, function () {
		const element = this;
		fileListModel.addEventListener('context', context => {
			const filterType = (context && context.preferences && context.preferences.filterType) || '',
				filteredTag = typeof filterType === 'string' ? filterType.startsWith(TAG_FILTER_PREFIX) && filterType.slice(TAG_FILTER_PREFIX.length) : filterType.filter(ft => ft.startsWith(TAG_FILTER_PREFIX)).map(ft => ft.slice(TAG_FILTER_PREFIX.length)).join(', ');

			if (filteredTag) {
				element.removeClass('hidden');
				element.find('[data-mm-role~="tag-description"]').text(trucateSentence(filteredTag, 50));
			} else {
				element.addClass('hidden');
			}
		});
	});
};
